import { useQuery } from "@tanstack/react-query";
import { getCodeList } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

export const CODELIST_QUERY_KEY = "CODELIST";

export const useCodeListQuery = () =>
  useQuery({
    queryKey: [CODELIST_QUERY_KEY],
    queryFn: processResponseWithApiProblemDetails(() => getCodeList()),
    refetchOnWindowFocus: false,
    staleTime: 10 * MS_TIME.minute,
  });
